import { BookingsHeader, BookingsPanel } from "@/components/organisms";
import { BookingFiltersProvider } from "@/components/organisms/Bookings/hooks/useBookingFilters";

export const Bookings = () => {
  return (
    <BookingFiltersProvider>
      {/* Cap + centre the content so the booking table doesn't stretch full-width on ultrawide
          (DEV-1367; matches the DSN-558 booking table cap and ClientHome). A no-op below 2360px.
          Capped here on the content column — not on the shared PrivateContent layout — so it never
          clips a full-bleed page background. Siblings (Clients/Companies/Drivers) already self-cap
          via their own Container. */}
      <div className="mx-auto flex w-full max-w-[2360px] flex-1 flex-col">
        <BookingsHeader />
        <BookingsPanel />
      </div>
    </BookingFiltersProvider>
  );
};
